import { legacyApiAuth } from '@wiggot/apis'
import { IResponseService } from '../../interfaces'

interface IGeneratePdfRequestBody {
  property_id: string
  type: string
  asesor_information?: boolean
}

interface IValidateDescriptionResponse {
  isValid: boolean
}

interface ICustomData {
  custom: boolean
  custom_title: string
  custom_description: string
  custom_images_id: string[]
  custom_cover_image: string
}

interface IGenerateExternalPdfRequestBody {
  external_id: string
  asesor_information?: boolean
}

export interface IPdfResponse {
  url: string
  pdfName: string
}

export const generatePdf = async ({
  propertyId,
  type = 'DATASHEET',
  customData = null,
  asesorInformation
}: {
  propertyId: string
  type?: 'DATASHEET' | 'ALREADY_CREATED'
  customData?: ICustomData | null
  asesorInformation?: boolean
}): Promise<IResponseService<IPdfResponse>> => {
  try {
    const response = await legacyApiAuth.post<
      IPdfResponse,
      IGeneratePdfRequestBody
    >(`/v2.0.2/pdf/live_generation`, {
      property_id: propertyId,
      type,
      asesor_information: asesorInformation,
      ...customData
    })

    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const validateDescription = async ({
  propertyId
}: {
  propertyId: string
}): Promise<IResponseService<IValidateDescriptionResponse>> => {
  try {
    const response = await legacyApiAuth.get<IValidateDescriptionResponse>(
      `/v2.0.2/pdf/validate_description/${propertyId}`
    )

    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const generateExternalPdf = async ({
  propertyId,
  asesorInformation
}: {
  propertyId: string
  asesorInformation?: boolean
}): Promise<IResponseService<IPdfResponse>> => {
  try {
    const response = await legacyApiAuth.post<
      IPdfResponse,
      IGenerateExternalPdfRequestBody
    >(`/v2.0.2/pdf/live_generation_external`, {
      external_id: propertyId,
      asesor_information: asesorInformation
    })

    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const generateBufferExternalPdf = async ({
  propertyId,
  asesorInformation
}: {
  propertyId: string
  asesorInformation?: boolean
}): Promise<IResponseService<IPdfResponse>> => {
  try {
    const response = await legacyApiAuth.post<
      IPdfResponse,
      IGenerateExternalPdfRequestBody
    >(`/v2.0.2/pdf/live_generation_external`, {
      external_id: propertyId,
      asesor_information: asesorInformation
    })

    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const generateBufferPdf = async ({
  propertyId,
  type = 'DATASHEET',
  customData = null,
  asesorInformation
}: {
  propertyId: string
  type?: 'DATASHEET' | 'ALREADY_CREATED'
  customData?: ICustomData | null
  asesorInformation?: boolean
}): Promise<IResponseService<IPdfResponse>> => {
  try {
    const response = await legacyApiAuth.post<
      IPdfResponse,
      IGeneratePdfRequestBody
    >(`/v2.0.2/pdf/live_generation`, {
      property_id: propertyId,
      type,
      asesor_information: asesorInformation,
      ...customData
    })

    return {
      isSuccess: true,
      data: response
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
